export default "__VITE_ASSET__CAdcy7DM__"